import customAxios from "./axiosConfig";

const AiAssistantService = {
  getCurrentChatBot() {
    const api_url = window.Urls['chat_bot_current_chat_bot']();
    return customAxios.get(api_url);
  },
  getResponse(data) {
    const api_url = window.Urls['chat_bot_send']();
    return customAxios.post(api_url, data);
  },
  resetContext() {
    const api_url = window.Urls['chat_bot_reset_context']();
    return customAxios.post(api_url);
  }
};

export default AiAssistantService;